import {
  UntypedFormGroup,
  UntypedFormControl,
  ValidatorFn,
  AbstractControl,
  FormControl,
  FormArray,
} from "@angular/forms";
import { IBOQAmendmentDetail } from "src/app/pages/master/models/boq.model";
import {
  IWorkOrder,
  IWorkOrderDetails,
} from "src/app/pages/master/models/workorder.model";

export function emailValidator(control: UntypedFormControl): {
  [key: string]: any;
} {
  var emailRegexp = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/;
  if (control.value && !emailRegexp.test(control.value)) {
    return { invalidEmail: true };
  }
}

export function matchingPasswords(
  passwordKey: string,
  passwordConfirmationKey: string
) {
  return (group: UntypedFormGroup) => {
    let password = group.controls[passwordKey];
    let passwordConfirmation = group.controls[passwordConfirmationKey];
    if (password.value !== passwordConfirmation.value) {
      return passwordConfirmation.setErrors({ mismatchedPasswords: true });
    }
  };
}
export function uniqueBOQValidator(boqNumbers: any[]): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (control.value !== undefined && boqNumbers.includes(control.value)) {
      return { duplicateBOQ: true };
    }
    return null;
  };
}
export function workOrderQtyValidator(
  workOrder: IWorkOrderDetails
): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (control.value === 0) {
      return { zero: true };
    } else {
      if (control.value < -workOrder.previousAmendment) {
        return { less: true, previousAmendment: -workOrder.previousAmendment };
      }
    }
    return null;
  };
}
export function sameProductTypeForSameProduct(
  boqDetails: any,
  index: number
): ValidatorFn {
  return (control: AbstractControl) => {
    const currentRowProduct = boqDetails.at(index).value?.product;
    const dupeRow = boqDetails.find((detail, i) => {
      const value = detail.value;
      return value.product == currentRowProduct && i !== index;
    });
    if (dupeRow && dupeRow.get("productType")?.value !== control.value) {
      return { dupeType: true };
    }
    return null;
  };
}
export function sameWorkTypeForSameWOCode(
  boqDetails: any,
  index: number
): ValidatorFn {
  return (control: AbstractControl) => {
    const currentWODetail = boqDetails.at(index).value?.workOrderDetailsKey;
    const dupeRow = boqDetails.find((detail, i) => {
      const value = detail.value;
      return value.workOrderDetailsKey == currentWODetail && i !== index;
    });
    if (dupeRow && dupeRow.get("workType")?.value !== control.value) {
      return { dupeType: true };
    }
    return null;
  };
}
export function nonZero(control: AbstractControl) {
  if (control.value === 0) {
    return { nonZero: true };
  }
  return null;
}
export function boqQtyValidator(boqDetail: IBOQAmendmentDetail): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (control.value === 0) {
      return { zero: true };
    } else {
      if (control.value < -boqDetail.boqQty) {
        return { less: true, quantity: -boqDetail.boqQty };
      }
    }
    return null;
  };
}
export function dupeProductForPO(boqDetails: any[], index:number): ValidatorFn {
  return (control: AbstractControl) => {
    if (control?.value) {
      const dupeRow = boqDetails?.filter(
        (boqDetail, i) => boqDetail?.getRawValue()?.productCode === control?.value
      );

      if (dupeRow?.length >= 2) {
        return { dupeProduct: true };
      }
    }
    return null;
  };
}
